import service from '../../http/axios';

// 查询标注分配列表
export const queryMarkDistribution = service({
  url: '/yinghe-api/imageDataManage/getCheckListByUpload',
});
// 标注分配
export const updateMarkDistribution = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScienceSchedule/assign',
});

// 查询任务列表
export const queryTaskList = service({
  url: '/yinghe-api/imageDataScienceSchedule/getMyTask',
});

// 查询可分配人员列表
export const queryDistributionUserList = service({
  url: '/yinghe-api/imageDataScienceSchedule/getAvailableMember',
});

// AI辅助标注
export const getAiTags = service({
  url: '/yinghe-api/tagResult/getAiTags',
});

// 获取标注审核过滤选项
export const getSelectOption = service({
  url: '/yinghe-api/imageDataScienceSchedule/getSelectOption',
});

// 获取分配过滤选项
export const getDistributionSelectOption = service({
  url: '/yinghe-api/imageDataManage/getSelectOption',
});
